export const CATEGORY_LIST_REQUEST = 'CATEGORY_LIST_REQUEST';
export const CATEGORY_LIST_SUCCESS = 'CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_FAIL = 'CATEGORY_LIST_FAIL';
export const SUBCATEGORY_LIST_REQUEST = 'SUBCATEGORY_LIST_REQUEST';
export const SUBCATEGORY_LIST_SUCCESS = 'SUBCATEGORY_LIST_SUCCESS';
export const SUBCATEGORY_LIST_FAIL = 'SUBCATEGORY_LIST_FAIL';

export const SKILLS_LIST_REQUEST = 'SKILLS_LIST_REQUEST';
export const SKILLS_LIST_SUCCESS = 'SKILLS_LIST_SUCCESS';
export const SKILLS_LIST_FAIL = 'SKILLS_LIST_FAIL';